module.exports = __webpack_public_path__ + "static/media/Materials and draft resolutions_22.05.2018.47611e35.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2018/Materials and draft resolutions_22.05.2018.pdf
// module id = 136
// module chunks = 0